/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.auth

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import androidx.navigation.toRoute
import kotlinx.serialization.Serializable
import studio.oddpods.cauce.core.base.ui.composableWithStayTransitions

@Serializable
data class OtpRoute(val email: String)

fun NavController.navigateToOtp(email: String, navOptions: NavOptions? = null) {
    navigate(OtpRoute(email = email), navOptions)
}

fun NavGraphBuilder.otpDestination(
    onAuthSuccess: () -> Unit,
    onNavigateBack: () -> Unit,
) {
    composableWithStayTransitions<OtpRoute> {
        val route = it.toRoute<OtpRoute>()
        OtpScreen(
            email = route.email,
            onAuthSuccess = onAuthSuccess,
            onNavigateBack = onNavigateBack,
        )
    }
}
